module.exports = __webpack_public_path__ + "static/media/icons_cotizacion.aa247643.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons_cotizacion.svg
// module id = 496
// module chunks = 0